import useHttp from './use-http';
import { ACTIVATION_BRIEF_STATUS_ACCEPTED } from '../../app-v2/constants/activation-brief';
import { ACTIVATION_STATUS_ARCHIVED } from '../../app-v2/constants/activation';
const useActivationBriefs = () => {
    const getActivationBriefs = (contactId) => {
        const url = `/contact/${contactId}/activation-briefs`;
        const { http } = useHttp();
        return http.get(url);
    };
    const getActivationBriefsForTaskSummary = (briefs = []) => {
        return briefs.filter((brief) => {
            var _a;
            return brief.status === ACTIVATION_BRIEF_STATUS_ACCEPTED &&
                ((_a = brief.activation) === null || _a === void 0 ? void 0 : _a.status) !== ACTIVATION_STATUS_ARCHIVED;
        });
    };
    return {
        getActivationBriefs,
        getActivationBriefsForTaskSummary
    };
};
export default useActivationBriefs;
